import PostCard from "@/components/post-card"
import { t } from "@/languages/i18n"
import { PostData } from "@/lib/config/types"
import { fetchPosts } from "@/services/postServices"
import { useEffect, useState } from "react"

const RelatedPostDetail = ({
  pageSize,
  currentPostId,
  locale,
}: {
  pageSize: string
  currentPostId?: number
  locale?: string
}) => {
  const [posts, setPosts] = useState<PostData[]>([])
  const [loading, setLoading] = useState(true)

  const getPosts = async () => {
    setLoading(true)
    try {
      const response = await fetchPosts({ pageSize }, locale)
      if (response?.data) {
        const filteredPosts = currentPostId
          ? response.data.filter((post: PostData) => post.id !== currentPostId)
          : response.data
        setPosts(filteredPosts)
      }
    } catch (error) {
      console.error("Error loading posts:", error)
    }
    setLoading(false)
  }

  useEffect(() => {
    getPosts()
  }, [pageSize, currentPostId])

  return (
    <div className="">
      {posts && posts.length > 0 && (
        <div className="mx-auto w-full sm:w-auto flex flex-col justify-center gap-10 lg:p-[7.5rem] py-8 px-4 container">
          <h2 className="text-5xl leading-[56px] font-semibold">{t("Curious minds click here")}</h2>
          <div className="grid sm:grid-cols-3 gap-6 sm:gap-10">
            {posts
              .filter(item => item.id !== currentPostId)
              .slice(0, 3)
              .map((post, index) => (
                <PostCard key={post.id} post={post} />
              ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default RelatedPostDetail
